/** @file Field check for an array whose items each pass a check. */
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check for an array of at least `minLength` items, each passing `item` at `<path>/<index>`. */
export function checkArray(item: FieldCheck, minLength = 0): FieldCheck {
  return (value, path) => {
    if (!Array.isArray(value) || value.length < minLength) {
      failField(path, minLength > 0 ? `array of at least ${minLength}` : 'array', value);
    }
    (value as unknown[]).forEach((v, i) => { item(v, `${path}/${i}`); });
  };
}
